module.exports = __webpack_public_path__ + "static/media/sample_medicare.dd16ac58.jpg";